<template>
  <v-dialog v-model="open" fullscreen style="z-index: 100001">
    <v-card class="pa-0">
      <div class="header-section-templates pa-2 pa-sm-3">
        <div class="header-section-templates__title-row mb-0">
          <h3 class="header-section-templates__title primary--text mb-0">Select Section Template</h3>
          <v-btn icon small class="header-section-templates__close" @click="handleCloseModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <v-divider />

      <div>
        <div class="header-section-templates__toolbar pa-3">
          <v-text-field
            v-model="search"
            placeholder="Search template..."
            outlined
            dense
            hide-details
            prepend-inner-icon="mdi-magnify"
            clearable
            class="search-template-input"
          />
          <div
            class="header-section-templates__controls"
            :class="{ 'header-section-templates__controls--single-btn': !isMultiSelectMode }"
          >
            <v-checkbox
              v-if="isMultiSelectMode"
              v-model="isAllSelected"
              label="All"
              hide-details
              dense
              class="header-section-templates__checkbox mt-0 pt-0 mx-2"
              @change="toggleSelectAll"
            />
            <v-btn
              class="header-section-templates__btn"
              :color="isMultiSelectMode ? 'grey darken-1' : 'primary'"
              :outlined="isMultiSelectMode"
              @click="toggleMultiSelectMode"
            >
              {{ isMultiSelectMode ? 'Reset' : 'Select multiple' }}
            </v-btn>
            <v-btn
              v-if="isMultiSelectMode"
              color="primary"
              class="header-section-templates__btn"
              :disabled="selectedTemplates.length === 0"
              @click="saveSelectedTemplates"
            >
              Insert ({{ selectedTemplates.length }})
            </v-btn>
          </div>
        </div>
        <v-divider />
      </div>
      <v-row>
        <v-col cols="12" md="2" style="padding-right: 0 !important">
          <div class="category-templates mt-2">
            <v-list>
              <template v-for="(item, index) in categoryTpl">
                <v-list-group
                  v-if="item.items && item.items.length"
                  :key="index + '-' + item.title"
                  :value="activeGroup === item.title"
                  :prepend-icon="item.action"
                  no-action
                  @click="toggleGroup(item)"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item
                    v-for="(child, index) in item.items"
                    :key="index + '-' + child.title"
                    :input-value="activeItem === child.title"
                    @click="handleSelectCategory(child)"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="child.title" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>

                <!-- for item not have children -->
                <v-list-item
                  v-else
                  :key="`${item.title}-${index}`"
                  :input-value="activeItem === item.title"
                  @click="handleSelectCategory(item)"
                >
                  <v-list-item-icon>
                    <v-icon>{{ item.action }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </div>
        </v-col>
        <v-col cols="12" md="10" style="padding-left: 0 !important">
          <div class="section-templates">
            <v-tooltip v-for="(template, index) in templates" :key="index" top>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="section-template-item"
                  :class="{ 'section-template-item--selected': isMultiSelectMode && isTemplateSelected(template) }"
                  v-bind="attrs"
                  v-on="isMultiSelectMode ? {} : on"
                  @click="isMultiSelectMode ? toggleTemplateSelection(template) : selectTemplate(template)"
                >
                  <v-checkbox
                    v-if="isMultiSelectMode"
                    :input-value="isTemplateSelected(template)"
                    class="section-template-checkbox"
                    hide-details
                    dense
                    color="primary"
                    small
                    @click.stop="toggleTemplateSelection(template)"
                  />
                  <div>
                    <img loading="lazy" :src="template.image" alt="" />
                  </div>
                </div>
              </template>
              <span>{{ isMultiSelectMode ? 'Click to select/deselect' : 'Click to select' }}</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>

      <div class="footer-section-templates">
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn text outlined @click="handleCloseModal">Cancel</v-btn>
        </v-card-actions>
      </div>
      <ProductReviewsOptions
        :show="showProductReviewsOptions"
        @close="showProductReviewsOptions = false"
        :template="selectedTemplate"
        :on-select="handleSelectTemplate"
        :product-review-type="productReviewType"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import productSectionTemplate from '@/mixins/productSectionTemplate';
import { handleSectionTemplate } from '@/views/website/products/components/description/common/utils';
import { TplType } from '@/mixins/productSectionTemplate';
import ProductReviewsOptions from './product-reviews-options.vue';
import productReviewsJson from '@/assets/json/product-reviews.json';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import { sectionType } from '@/views/website/products/components/description/common/types';
import { replaceImageUrl } from '../common/utils';

export default {
  name: 'SelectSectionTemplate',
  mixins: [productSectionTemplate],
  components: {
    ProductReviewsOptions,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    hurrybox: {
      type: Boolean,
      default: false,
    },
    orderpolicy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      TplType,
      templates: [],
      showProductReviewsOptions: false,
      selectedTemplate: null,
      productReviewType: '',
      isMultiSelectMode: false,
      selectedTemplates: [],
      isAllSelected: false,
    };
  },
  watch: {
    search(newVal) {
      this.templates = this.sectionTemplates.filter(
        template =>
          template.title.toLowerCase().includes(newVal.toLowerCase()) ||
          template.type.toLowerCase().includes(newVal.toLowerCase()),
      );
    },
    templates() {
      if (this.isMultiSelectMode) {
        this.selectedTemplates = this.selectedTemplates.filter(sel =>
          this.templates.some(t => t.type === sel.type && t.image === sel.image),
        );
        this.isAllSelected =
          this.selectedTemplates.length > 0 && this.selectedTemplates.length === this.templates.length;
      }
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit('close');
      this.selectedTemplates = [];
      this.isAllSelected = false;
    },
    handleSelectCategory(item) {
      this.activeItem = item.title;
      if (item.title === 'All templates') {
        this.templates = [...this.sectionTemplates];
        //remove active
        this.categoryTpl.forEach(item => {
          item.active = false;
        });
      } else {
        this.templates = this.sectionTemplates.filter(template => template.tplType === item.tplType);
      }
    },
    toggleGroup(item) {
      console.log(item);
      // this.activeGroup = this.activeGroup === item.title ? null : item.title
    },
    selectTemplate(template) {
      switch (template.type) {
        case sectionType.sectionProductReviews: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionProductReviews;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionProductReviews02: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionProductReviews02;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionProductReviews03: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionProductReviews03;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionProductReviews04: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionProductReviews04;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionProductReviews05: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionProductReviews05;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionProductReviews06: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionProductReviews06;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionGatorzReviews: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionGatorzReviews;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionSaintbrandReviews: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionSaintbrandReviews;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionLosaprilyReviews: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionLosaprilyReviews;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionFastvaluedealReviews: {
          this.showProductReviewsOptions = true;
          this.productReviewType = sectionType.sectionFastvaluedealReviews;
          this.selectedTemplate = template;
          break;
        }
        case sectionType.sectionReviewGrid: {
          const html = updateHtmlFromData.sectionReviewGrid(template.html, {
            'body-review': this.generateRandomReviews(3),
          });
          this.handleSelectTemplate({ ...template, html });
          break;
        }
        case sectionType.sectionReviewGrid02: {
          const html = updateHtmlFromData.sectionReviewGrid02(template.html, {
            'body-review': this.generateRandomReviews(3),
          });
          this.handleSelectTemplate({ ...template, html });
          break;
        }
        case sectionType.sectionOrderInfo: {
          const html = updateHtmlFromData.sectionOrderInfo(template.html, {
            'body-review': this.generateRandomReviews(3),
          });
          this.handleSelectTemplate({ ...template, html });
          break;
        }
        case sectionType.sectionReviewInfiniteMarquee: {
          // Auto-duplicate items when selecting new section to ensure smooth animation
          const defaultImages = this.getDefaultReviewImages();
          const html = updateHtmlFromData.sectionReviewInfiniteMarquee(template.html, {
            'review-images': defaultImages,
          });
          this.handleSelectTemplate({ ...template, html });
          break;
        }
        case sectionType.sectionSocialComment: {
          const html = updateHtmlFromData.sectionSocialComment(template.html, {
            comments: this.generateRandomComments(),
          });
          this.handleSelectTemplate({ ...template, html });
          break;
        }
        case sectionType.sectionReviewGrid04: {
          const html = updateHtmlFromData.sectionReviewGrid04(template.html, {
            reviewsList: this.generateRandomReviews(10),
          });
          this.handleSelectTemplate({ ...template, html });
          break;
        }
        default:
          this.handleSelectTemplate(template);
      }
    },
    toggleMultiSelectMode() {
      this.isMultiSelectMode = !this.isMultiSelectMode;
      if (!this.isMultiSelectMode) {
        this.selectedTemplates = [];
        this.isAllSelected = false;
      }
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.activeItem = 'All templates';
        this.templates = [...this.sectionTemplates];
        this.selectedTemplates = [...this.templates];
      } else {
        this.selectedTemplates = [];
      }
    },
    isTemplateSelected(template) {
      return this.selectedTemplates.some(t => t.type === template.type && t.image === template.image);
    },
    toggleTemplateSelection(template) {
      const index = this.selectedTemplates.findIndex(t => t.type === template.type && t.image === template.image);
      if (index >= 0) {
        this.selectedTemplates.splice(index, 1);
      } else {
        this.selectedTemplates.push(template);
      }
      this.isAllSelected = this.selectedTemplates.length === this.templates.length;
    },
    saveSelectedTemplates() {
      const hurryboxTplTypes = [TplType.FreeLayoutHurryBox];
      const policyTplTypes = [TplType.guaranteedSafeCheckout, TplType.orderInfo, TplType.freestyleOrderPolicy];

      const descTemplates = [];
      const hurryboxTemplates = [];
      const policyTemplates = [];

      for (const template of this.selectedTemplates) {
        const processed = this.processTemplate(template);
        const result = handleSectionTemplate.insertNewId(processed);

        if (hurryboxTplTypes.includes(template.tplType)) {
          hurryboxTemplates.push(result);
        } else if (policyTplTypes.includes(template.tplType)) {
          policyTemplates.push(result);
        } else {
          descTemplates.push(result);
        }
      }

      if (descTemplates.length) this.$root.$emit('insert-all-desc-sections', descTemplates);
      if (hurryboxTemplates.length) this.$root.$emit('insert-all-hurrybox-sections', hurryboxTemplates);
      if (policyTemplates.length) this.$root.$emit('insert-all-policy-sections', policyTemplates);
      this.$emit('close');
      this.selectedTemplates = [];
      this.isAllSelected = false;
    },
    processTemplate(template) {
      switch (template.type) {
        case sectionType.sectionReviewGrid:
          return {
            ...template,
            html: updateHtmlFromData.sectionReviewGrid(template.html, { 'body-review': this.generateRandomReviews(3) }),
          };
        case sectionType.sectionReviewGrid02:
          return {
            ...template,
            html: updateHtmlFromData.sectionReviewGrid02(template.html, {
              'body-review': this.generateRandomReviews(3),
            }),
          };
        case sectionType.sectionOrderInfo:
          return {
            ...template,
            html: updateHtmlFromData.sectionOrderInfo(template.html, { 'body-review': this.generateRandomReviews(3) }),
          };
        case sectionType.sectionReviewInfiniteMarquee:
          return {
            ...template,
            html: updateHtmlFromData.sectionReviewInfiniteMarquee(template.html, {
              'review-images': this.getDefaultReviewImages(),
            }),
          };
        case sectionType.sectionSocialComment:
          return {
            ...template,
            html: updateHtmlFromData.sectionSocialComment(template.html, { comments: this.generateRandomComments() }),
          };
        default:
          return template;
      }
    },
    handleSelectTemplate(template) {
      this.$emit('select', handleSectionTemplate.insertNewId(template));
      this.$emit('close');
    },
    generateRandomReviews(count = 3) {
      const randomReviews = [];
      const pickedSet = new Set();

      while (randomReviews.length < count && pickedSet.size < productReviewsJson.length) {
        const item = productReviewsJson[Math.floor(Math.random() * productReviewsJson.length)];
        const key = `${item.fullName || ''}-${item.avatar || ''}`;

        if (!pickedSet.has(key)) {
          pickedSet.add(key);
          randomReviews.push({
            title: 'Title',
            content: 'Great product!',
            name: item.fullName || '',
            rating: 5,
            avatar: item.avatar || '',
          });
        }
      }
      return randomReviews;
    },
    generateRandomComments(count = 2, maxReplies = 1) {
      if (!Array.isArray(productReviewsJson) || productReviewsJson.length === 0) {
        return [];
      }

      const randomItem = arr => arr[Math.floor(Math.random() * arr.length)];

      const generateId = () =>
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random()
              .toString(36)
              .slice(2)}`;

      const pickedAuthors = new Set();
      const comments = [];

      while (comments.length < count && pickedAuthors.size < productReviewsJson.length) {
        const authorItem = randomItem(productReviewsJson);
        const authorKey = `${authorItem.fullName}-${authorItem.avatar}`;

        if (pickedAuthors.has(authorKey)) continue;
        pickedAuthors.add(authorKey);

        const commentId = generateId();

        // random replies count
        const repliesCount = Math.floor(Math.random() * (maxReplies + 1));
        const replies = [];

        for (let i = 0; i < repliesCount; i++) {
          const replyAuthor = randomItem(productReviewsJson);

          replies.push({
            id: generateId(),
            parentId: commentId,
            author: {
              name: replyAuthor.fullName || '',
              avatar: replyAuthor.avatar || '',
            },
            content: 'Enter reply content...',
            likesCount: Math.floor(Math.random() * 20),
            createdAt: 'a day ago',
          });
        }

        comments.push({
          id: commentId,
          author: {
            name: authorItem.fullName || '',
            avatar: authorItem.avatar || '',
          },
          content: 'Enter comment content...',
          likesCount: Math.floor(Math.random() * 50),
          replies,
          createdAt: 'a day ago',
        });
      }
      return comments;
    },
    getDefaultReviewImages() {
      const defaultImages = [
        replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2026/03/24/image-69c1eaca767656111e27964c.gif?w=50&h=50&q=80',
        ),
        replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2026/03/24/image-69c1eae160bc95a2a8711144.gif?w=50&h=50&q=80',
        ),
        replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2026/03/24/image-69c1eaf1f84f96f32c8e4a74.gif?w=50&h=50&q=80',
        ),
        replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2026/03/24/image-69c1eb014e4083ebe832e7be.gif?w=50&h=50&q=80',
        ),
        replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2026/03/24/image-69c1eb14cd49fcce49a8b535.gif?w=50&h=50&q=80',
        ),
      ];

      return defaultImages.map(avatar => ({ avatar }));
    },
  },
  created() {
    if (this.hurrybox) {
      this.activeItem = 'Free layout HurryBox';
      this.activeGroup = 'HurryBox';
      this.categoryTpl = this.categoryTpl.map(item => {
        if (item.title === 'HurryBox') {
          return {
            ...item,
            active: true,
          };
        }
        return {
          ...item,
        };
      });
      this.templates = this.sectionTemplates.filter(template => template.tplType === TplType.FreeLayoutHurryBox);
    } else if (this.orderpolicy) {
      this.activeItem = 'Order Info';
      this.activeGroup = 'Order Policy';
      this.categoryTpl = this.categoryTpl.map(item => {
        if (item.title === 'Order Policy') {
          return {
            ...item,
            active: true,
          };
        }
        return {
          ...item,
        };
      });
      this.templates = this.sectionTemplates.filter(template => template.tplType === TplType.orderInfo);
    } else {
      this.templates = [...this.sectionTemplates];
    }
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-dialog--fullscreen {
  overflow: hidden;
  @media (max-width: 1024px) {
    overflow-y: auto;
  }
}
.header-section-templates {
  border-bottom: none;

  &__title-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 10px;
  }

  &__title {
    flex: 1;
    min-width: 0;
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.35;
    word-break: break-word;
  }

  &__close {
    flex-shrink: 0;
    margin-top: -2px;
  }

  &__toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  &__controls {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 0;
  }

  &__checkbox {
    flex-shrink: 0;
  }

  &__btn {
    flex-shrink: 0;
  }

  @media (max-width: 599px) {
    &__title {
      font-size: 1rem;
    }

    &__toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    &__controls {
      flex: none;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      width: 100%;

      &--single-btn {
        grid-template-columns: 1fr;
      }
    }

    &__checkbox {
      grid-column: 1 / -1;
      justify-self: start;
      margin-top: 0 !important;
      padding-top: 0 !important;
    }

    &__btn {
      width: 100%;
      min-width: 0;
    }
  }
}

.search-template-input {
  flex: 1;
  width: 100%;
  max-width: 500px;

  ::v-deep .v-input__slot {
    min-height: 36px !important;
  }
}

.category-templates {
  padding-bottom: 0;
  // border-right: solid 1px #c1c1c1;
  @media (min-width: 1024px) {
    overflow-y: auto;
    max-height: calc(100vh - 68px - 68px - 5px);
    padding-bottom: 60px;
  }
}
.section-templates {
  max-height: calc(100vh - 68px - 68px - 5px);
  overflow-y: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px;
  padding-bottom: 60px;
}

.section-template-item {
  width: calc((100% - 24px) / 3);
  border-color: var(--v-primary-base);
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  min-height: 226px;

  &:hover {
    border-color: var(--v-primary-base);
    background-color: #f5f5f5;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &--selected {
    border-color: var(--v-primary-base);
    z-index: 2;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--v-primary-base);
      box-shadow: 0 0 0 1px var(--v-primary-base);
      opacity: 0.1;
    }
  }

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  @media screen and (max-width: 768px) {
    width: calc((100% - 24px) / 2);
  }
}

.section-template-checkbox {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;

  ::v-deep .v-input--selection-controls__input {
    margin: 0;
  }
}
.footer-section-templates {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 3;
}

.template-icon {
  margin-right: 16px;
  flex-shrink: 0;
}

.template-content {
  flex: 1;
}

.template-title {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.template-description {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

.template-arrow {
  flex-shrink: 0;
}

.v-list-item--link:before {
  background-color: aqua;
}
.v-list-item--active {
  color: #0081c7;
}
</style>
